import { render } from "./Team.vue?vue&type=template&id=690581d7"
import script from "./Team.vue?vue&type=script&setup=true&lang=js"
export * from "./Team.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/components/Team.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "690581d7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('690581d7', __exports__)) {
    console.log('reload')
    api.reload('690581d7', __exports__)
  }
  
  module.hot.accept("./Team.vue?vue&type=template&id=690581d7", () => {
    console.log('re-render')
    api.rerender('690581d7', render)
  })

}


export default __exports__